<div class="quick-panel-custom m-16" >
  <div class="display-block">
    <mat-icon class="font-size-52 text-col h-68 w-68">hourglass_empty</mat-icon>
  </div>
  <p class="p-0 m-0 text-col font-size-24" *ngIf="noDataFoundMessage">{{ noDataFoundMessage | translate }}</p>
  <p class="p-0 m-0 text-col font-size-24" *ngIf="!noDataFoundMessage">{{ 'NO_DATA_FOUND' | translate}}</p>
</div>



<div class="no-data-found p-32 text-center" *ngIf="noDataFound && noDataFound.templateName">
  <div class="no-data-icon mb-8 h-48" *ngIf="noDataFound">
    <mat-icon *ngIf="noDataFound.slNetworkIcon" [ngClass]="[noDataFound.slNetworkIcon, noDataFound.iconHeightClass, noDataFound.iconWidthClass, noDataFound.iconFontSizeClass]"
      class="secondary-text-color-two"></mat-icon>
    <mat-icon *ngIf="noDataFound.matIconClass" class="h-48 w-48 font-size-48 secondary-text-color-two">error</mat-icon>
  </div>
  <div class="description" *ngIf="noDataFound">
    <p class="p-0 m-0 primary-text-color legacy-bold mb-4" [ngClass]="[noDataFound.smTitleFontSize]" *ngIf="noDataFound.noDataSmallTitle">{{noDataFound.noDataSmallTitle
      | translate}}</p>
    <p class="p-0 m-0 primary-text-color mb-4" [ngClass]="[noDataFound.lgTitleFontSize]" *ngIf="noDataFound.noDataLargeTitle">{{noDataFound.noDataLargeTitle
      | translate}}</p>
    <p class="p-0 m-0 font-size-16 line-height-18 secondary-text-color-two mb-16" *ngIf="noDataFound.noDataMessage">{{noDataFound.noDataMessage
      | translate}}</p>
    <div *ngIf="noDataFound && noDataFound.featureGuardEnable">
     <!-- / <app-platform-feature-guard [activatesWith]="noDataFound.featureGuardEnable"> -->
        <button *ngIf="noDataFound.button" mat-raised-button color="primary" class="legacy-bold" (click)="onClickButton()">
          <mat-icon class="font-size-20 white-color w-20 line-height-18 h-20 mr-4">{{noDataFound.buttonIcon}}</mat-icon>
          {{noDataFound.noDataButtonText | translate}}
        </button>
      <!-- </app-platform-feature-guard> -->
    </div>
    <div *ngIf="noDataFound && !noDataFound.featureGuardEnable">
      <button *ngIf="noDataFound.button" mat-raised-button color="primary" class="legacy-bold" (click)="onClickButton()">
        <mat-icon class="font-size-20 white-color w-20 line-height-18 h-20 mr-4">{{noDataFound.buttonIcon}}</mat-icon>
        {{noDataFound.noDataButtonText | translate}}
      </button>
    </div>
  </div>
</div>
